const data = {
  // 区域数组
  regions: [],
  // 监控设备数组
  encoders: [],
  // 监控子设备数组
  auxMonitoringDevices: [],
  // 服务器数组
  servers: [],
  // 服务数组
  services: [],
  // 地图数组
  maps: [],
  // 地图节点模型数组
  mapNodeModels: [],
  // 时刻表
  runSchedules: [],
  // 项目
  projects: [],
  // 部门
  departments: [],
  // 人员
  persons: [],
  // 用户数组
  users: [],
  // 系统菜单
  systemMenus: [],
  // 系统设定
  systemSettings: []
}

export default data



// WEBPACK FOOTER //
// ./src/api/data.js